import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 14 19" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...this.props}><path d="M.79 8.548c-.69.69-.69 1.81 0 2.5l7.603 7.6a.975.975 0 0 0 .598.248h4.636c.193 0 .24-.112.103-.248l-8.604-8.603-.248-.247L9.57 5.106 13.894.782c.136-.136.09-.248-.103-.247L9.136.552a.972.972 0 0 0-.598.25L.79 8.547z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/chevron.inline.svg